/**
 * 绑定 TableController 到 Vuex 全局 getter/list
 * @param {TableController} tableCtrl
 * @param {Function} getListFn - 返回数组的 getter（如 () => store.getters['agentStore/agents']）
 * @param {Vue} vm - 当前 Vue 实例（用于 watch）
 */
export function bindTableControllerToVuex(tableCtrl, getListFn, vm) {
  // 初始化
  tableCtrl.setTableData(getListFn() || []);
  // 监听全局 getter/list 变化，自动同步
  vm.$watch(
    getListFn,
    (val) => {
      tableCtrl.setTableData(val || []);
    },
    { immediate: true, deep: true }
  );
}

/**
 * 加载列表数据并映射状态
 * @param {Function} fetchListFn - 返回 Promise 的函数，用于请求列表数据
 * @param {TableController} tableCtrl
 * @param {Object} [options] - 可选项，如 loading 状态字段名
 * @returns {Promise<void>}
 */
export async function delegateLoadTable(store, storeFetchFn, storeListGetter) {
  console.log("delegateLoadTable", storeFetchFn, storeListGetter);
  await store.dispatch(storeFetchFn);
  const list = store.getters[storeListGetter];
  return list || [];
}
